import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    filterManagerButton: {
      fontWeight: 600,
      width: '100%',
    },
    fieldDescription: {
      fontSize: '12px',
      marginTop: '4px',
      fontWeight: 300,
    },
    options: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '12px',
      gap: '12px',
    },
    advanced: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '8px',
      gap: '10px',
      '& .timestamp-field': {
        marginTop: '8px',
      },
    },
    bottomButtons: {
      marginTop: '12px',
    },
    groupPane: {
      '& > div:first-child': {
        paddingLeft: '0',
        paddingRight: '0',
      },
    },
    pullModeCheckbox: {
      marginTop: '12px',
    },
  });
};
